import { ARTICLES_LIMIT } from '../../utils/constants';
import {
    FETCH_ARTICLES_GESUNDE_KOMMUNE_REQUEST,
    FETCH_ARTICLES_GESUNDE_KOMMUNE_SUCCESS,
    FETCH_ARTICLES_GESUNDE_KOMMUNE_FAILURE,
    FETCH_ARTICLES_GESUNDE_KOMMUNE_CLEAN_UP,
    UPDATE_GESUNDE_KOMMUNE_PAGE_START_PARAM,
} from '../constants/gesundeKommuneTypes';

const initialState = {
    loading: false,
    articles: [],
    error: '',
    start: 0,
};

const articlesGesundeKommuneReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ARTICLES_GESUNDE_KOMMUNE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ARTICLES_GESUNDE_KOMMUNE_SUCCESS:
            return {
                loading: false,
                articles: [...state.articles, ...action.payload.articles],
                error: '',
                start: state.start,
            };
        case FETCH_ARTICLES_GESUNDE_KOMMUNE_FAILURE:
            return {
                loading: false,
                articles: null,
                error: action.payload,
            };
        case FETCH_ARTICLES_GESUNDE_KOMMUNE_CLEAN_UP:
            return {
                articles: [],
            };
        case UPDATE_GESUNDE_KOMMUNE_PAGE_START_PARAM:
            return {
                ...state,
                start: state.start + ARTICLES_LIMIT,
            };
        default:
            return state;
    }
};

export default articlesGesundeKommuneReducer;
